import React from "react"
import { graphql, Link } from "gatsby"

import Layout from '../components/layout'
// import Introduction from "../components/Services/Introduction"
import Services from '../components/Services/Services'
import Breadcrumb from "../components/Global/Breadcrumb"



function ExaminationsTemplate(props) {
    let data = props.data.wpgraphql;

    console.log(data)

    function getBreadcrumb() {
        let bCrumb = [];
        bCrumb.push({
            text: "Home",
            url: `${props.pageContext.language !== "EL" ? "/" + props.pageContext.language.toLowerCase() : "/"}`
        })
        bCrumb.push({
            text: data.page.breadcrumbAcf.breadcrumbName,
            url: `${props.pageContext.language !== "EL" ? "/" + props.pageContext.language.toLowerCase() : ""}${props.pageContext.currentPage}`
        })
        return bCrumb;
    }

    function constructMetaData(page, currentPage, language) {
        let payload = {
            title: page.seo.title,
            description: page.seo.metaDesc,
            canonical: `https://plusmedical.gr${currentPage}`,
            fbTitle: page.seo.opengraphTitle ? page.seo.opengraphTitle : page.seo.title,
            fbDescription: page.seo.opengraphDescription ? page.seo.opengraphDescription : page.seo.metaDesc,
            fbUrl: `https://plusmedical.gr${currentPage}`,
            fbType: "website",
            locale: language.toLowerCase(),
            image: page.seo.opengraphImage ? page.seo.opengraphImage.sourceUrl : ""
        }

        console.log(payload)
        return payload
    }

    return (
        <div>
            <Layout
                headerMenu={props.pageContext.headerMenu}
                footerMenu={props.pageContext.footerMenu}
                recentPosts={data.posts}
                currentPage={{ currentPage: props.pageContext.currentPage, language: props.pageContext.languageName }}
                availableVersions={props.pageContext.availablePages}
                metaData={constructMetaData(data.page, props.pageContext.currentPage, props.pageContext.language)}
                services={props.pageContext.servicesCategories}
                examinations={props.pageContext.examinationsCategories}
                preHeader={data.template.contactInformationTemplate}
            >
                <div>
                    {data.page.breadcrumbAcf.breadcrumbName && (
                        <section>
                            <Breadcrumb list={getBreadcrumb()} image={data.page.breadcrumbAcf.image} h1={data.page.breadcrumbAcf.breadcrumbName} />
                        </section>
                    )}
                    <section>
                        <Services data={{ services: data.examinationCategories.edges }} stylez={{ paddingTop: "0px" }} />
                    </section>
                </div>
            </Layout>
        </div>
    )
}

export default ExaminationsTemplate

export const pageQuery = graphql`query GET_EXAMINATIONS($id: ID!, $language: WPGraphQL_LanguageCodeFilterEnum, $themeTemplateUri: ID!) {
  wpgraphql {
    page(id: $id) {
      seo {
        canonical
        title
        metaDesc
        opengraphDescription
        opengraphTitle
        opengraphImage {
          sourceUrl
        }
      }
      breadcrumbAcf {
        breadcrumbName
        image {
          sourceUrl
          altText
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH, quality: 100)
            }
          }
        }
      }
    }
    examinationCategories(where: {language: $language}) {
      edges {
        node {
          name
          examinations(first: 200, where: {orderby: {field: MENU_ORDER, order: ASC}}) {
            edges {
              node {
                uri
                title
                excerpt
                servicesAcf {
                  smallIcon {
                    altText
                    sourceUrl
                    imageFile {
                      childImageSharp {
                        gatsbyImageData(width: 40, placeholder: NONE, layout: FIXED)
                      }
                    }
                  }
                  featuredImage {
                    altText
                    sourceUrl
                    imageFile {
                      childImageSharp {
                        gatsbyImageData(width: 360, height:270, placeholder: NONE, layout: CONSTRAINED, quality:100)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    template(id: $themeTemplateUri, idType: SLUG) {
      contactInformationTemplate {
        telephoneNumber
        supportEmail
        hoursLabel
        hoursTitle
        form {
          title
          subTitle
          fullName
          email {
            label
            errorMessage
          }
          subject
          message {
            label
            errorMessage
          }
          telephone {
            label
            errorMessage
          }
          sendButton
        }
        responseMessages {
          success
          failed
        }
      }
    }
    posts(
      first: 2
      where: {language: $language, orderby: {field: DATE, order: ASC}}
    ) {
      ...RecentPostsFragment
    }
  }
}
`
